import { render, staticRenderFns } from "./HomeCategories.vue?vue&type=template&id=6b5a8754&scoped=true&"
import script from "./HomeCategories.vue?vue&type=script&lang=js&"
export * from "./HomeCategories.vue?vue&type=script&lang=js&"
import style0 from "./HomeCategories.vue?vue&type=style&index=0&id=6b5a8754&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5a8754",
  null
  
)

export default component.exports